import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Suppliers/Balance_logs/tables";
import headers from "../../../../Data/Tables/Suppliers/Balance_logs/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { get_supplier_balance_logs } from "../../../../Controllers/Suppliers/Balance";
import UserCurrency from "../../../../Componets/UserCurrency";

const SupplierBalanceLogs = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState([]);
  const [summary, setSummary] = useState({
    totalDeposits: 0,
    totalWithdrawals: 0,
    currentBalance: 0,
  });
  const id = localStorage.getItem("Supplier_Id");

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};
    header?.components?.map((value) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      type: headerdata?.type,
      payment_method: headerdata?.payment_method,
      date: headerdata?.date,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;
    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchSummary = async (logs = []) => {
    try {
      let totalDeposits = 0;
      let totalWithdrawals = 0;
      let currentBalance = 0;

      logs.forEach((log) => {
        const amount = log.amount || 0;

        if (log.type === "deposit") {
          totalDeposits += amount;
        } else if (log.type === "withdrawal" || log.type === "payment") {
          totalWithdrawals += amount;
        }
      });

      if (logs.length > 0) {
        currentBalance = logs[0].new_balance || 0;
      }

      setSummary({
        totalDeposits,
        totalWithdrawals,
        currentBalance,
      });
    } catch (error) {
      toast.error("Failed to calculate summary");
    }
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        supplier: id,
        search: tabledata?.search,
        type: tabledata?.type,
        payment_method: tabledata?.payment_method,
        date: tabledata?.date,
        page: tabledata?.currentPage,
        limit: 10,
      };

      const response = await get_supplier_balance_logs(params);

      if (response?.success) {
        const balanceLogs = response?.data?.data || [];

        fetchSummary(balanceLogs);

        const tableData = balanceLogs.map((log) => {
          const getTypeColor = (type) => {
            switch (type) {
              case "deposit":
                return "bg-green-100 text-green-600";
              case "withdrawal":
                return "bg-red-100 text-red-600";
              case "payment":
                return "bg-blue-100 text-blue-600";
              case "adjustment":
                return "bg-yellow-100 text-yellow-600";
              default:
                return "bg-gray-100 text-gray-600";
            }
          };

          const getTypeLabel = (type) => {
            switch (type) {
              case "deposit":
                return "Deposit";
              case "withdrawal":
                return "Withdrawal";
              case "payment":
                return "Payment";
              case "adjustment":
                return "Adjustment";
              default:
                return type;
            }
          };

          const getAmountColor = (type) => {
            if (type === "deposit") {
              return "text-green-600";
            } else if (type === "withdrawal" || type === "payment") {
              return "text-red-600";
            }
            return "text-gray-600";
          };

          const getAmountPrefix = (type) => {
            if (type === "deposit") {
              return "+";
            } else if (type === "withdrawal" || type === "payment") {
              return "-";
            }
            return "";
          };

          return {
            Date: log.payment_date
              ? new Date(log.payment_date).toLocaleDateString()
              : new Date(log.created).toLocaleDateString(),
            "Transaction Type": (
              <span
                className={`${getTypeColor(
                  log.type
                )} text-sm px-2 py-1 rounded-lg`}
              >
                {getTypeLabel(log.type)}
              </span>
            ),
            Amount: (
              <span className={getAmountColor(log.type)}>
                {getAmountPrefix(log.type)}<UserCurrency />  {Math.abs(log.amount).toFixed(3)}
              </span>
            ),
            "PO Number":
              log.po_ids?.length > 0
                ? log.po_ids.map(po => `#${po.number}`).join(", ")
                : "-",
            "Previous Balance": `${log.previous_balance?.toFixed(3) || "0.000"}`,
            "New Balance": `${log.new_balance?.toFixed(3) || "0.000"}`,
            "Payment Method": log.payment_method || "-",
            "Reference Number": log.reference_number || "-",
            Description: log.description || "-",
            "Created By": log.created_by?.name || "-",
          };
        });

        setBody(tableData);

        setPagination({
          currentPage: params.page || 1,
          totalCount: response?.data?.totalCount,
          totalPages: response?.data?.totalPages,
        });
      } else {
        toast.error("Failed to fetch balance logs");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoader(false);
    }
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    if (id) {
      fetchData();
      headerReset();
    }
  }, [id]);

  return (
    <div>
      <Header headers={header} setHeaders={setHeader} formdata={formdata}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 pt-4">
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className="text-gray-700 mb-2">Current Balance</h3>
            <p
              className={`${(summary.currentBalance || 0) >= 0
                ? "text-green-600"
                : "text-red-600"
                }`}
            >
              <UserCurrency />  {summary.currentBalance.toFixed(3)}
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className="text-gray-700 mb-2">Total Deposits</h3>
            <p className=" text-green-600">
              <UserCurrency />  {summary.totalDeposits.toFixed(3)}
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className="text-gray-700 mb-2">Total Withdrawals</h3>
            <p className=" text-red-600">
              <UserCurrency />  {summary.totalWithdrawals.toFixed(3)}
            </p>
          </div>
        </div>
        <Loadercomponent loader={loader}>
          <Table
            head={tables}
            body={body}
            pagination={pagination}
            paginationdata={paginationdata}
            summary={2}
          />
        </Loadercomponent>
      </Header>
    </div>
  );
};

export default SupplierBalanceLogs;